const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const MS_PER_DAY = 1000 * 60 * 60 * 24;

let nextEventPromise = null;

/**
 * Next upcoming public event, or null. The request is shared so the ribbon and
 * the home page banner only hit /api/events once per page load.
 */
export const fetchNextEvent = () => {
  if (!nextEventPromise) {
    nextEventPromise = fetch(`${API}/events`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data?.items?.[0] || null)
      .catch(() => null);
  }
  return nextEventPromise;
};

// Test hook: forget the shared request.
export const resetNextEventCache = () => {
  nextEventPromise = null;
};

/**
 * Whole calendar days from `now` until the event. Event dates are stored as
 * naive local (Eastern) times, so both sides are compared as local dates.
 */
export const daysUntil = (dateString, now = new Date()) => {
  const event = new Date(dateString);
  const eventDay = new Date(event.getFullYear(), event.getMonth(), event.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((eventDay - today) / MS_PER_DAY);
};

export const countdownLabel = (days) => {
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  return `${days} days away`;
};

// "1st Annual Owaza Kansha-Sai Tournament" -> "Kansha-Sai Tournament"
export const shortEventTitle = (title) =>
  title.replace(/^\d+(st|nd|rd|th)\s+Annual\s+/i, '').replace(/^Owaza\s+/i, '');

export const formatShortDate = (dateString) =>
  new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
